module.exports = __webpack_public_path__ + "static/logo_header_small-c01b65f7f1620d0bf38e8a52c3158962.svg";